import { useCallback } from 'react';

export const useRootVariable = () => {
  const setVariable = useCallback((variableName: string, value: string) => {
    (document.querySelector(':root') as HTMLElement).style.setProperty(`--${variableName}`, value);
  }, []);
  return { setVariable };
};
